import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../../assets/images/madlogic-logo.png';
import './styles.css';

const Preloader = ({ visible }) => (
  <div
    className="preloader-wrapper"
    style={{ display: visible ? '' : 'none' }}
  >
    <div className="preloader">
      <img className="logo" src={Logo} alt="Madlogic" />
      <div className="loading">
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
      </div>
    </div>
  </div>
);

Preloader.propTypes = {
  visible: PropTypes.bool
};

Preloader.defaultProps = {
  visible: false
};

export default Preloader;



// WEBPACK FOOTER //
// ./src/components/Loading/Preloader.js